import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id 8F37BBCB-35D2-4FAF-88ED-59252659885D
 * name text-recognition
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-recognition.svg
 * tags
 */
export const TextRecognitionIcon = createSvgIcon(<><path d="M2 4C2 2.9 2.9 2 4 2H8V4H4V8H2V4M22 20C22 21.11 21.11 22 20 22H16V20H20V16H22V20M4 22C2.9 22 2 21.11 2 20V16H4V20H8V22H4M20 2C21.11 2 22 2.9 22 4V8H20V4H16V2H20M9 7V9H11V17H13V9H15V7H9Z" /></>, 'TextRecognitionIcon');
export default TextRecognitionIcon